var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SplitPage from '../../../../components/SplitPage';
import CreateUsers from './hooks';
import Input from '../../../../components/Input';
import t from '../../../../lib/translate';
import FormActions from '../../../../components/FormActions';
import LabeledMultiSelect from '../../components/LabeledMultiSelect';
var CreateUser = function () {
    var _a = CreateUsers.useContainer(), userOwnerParties = _a.userOwnerParties, adminOwnerParties = _a.adminOwnerParties, userAccessLevels = _a.userAccessLevels, adminAccessLevels = _a.adminAccessLevels, setUserOwnerParties = _a.setUserOwnerParties, setUserAccessLevels = _a.setUserAccessLevels, setUsername = _a.setUsername, createUserFunc = _a.createUserFunc;
    if (!userOwnerParties || !userAccessLevels)
        return _jsx("p", { children: t('users.not.found') });
    return (_jsx(SplitPage, { children: _jsxs("form", __assign({ onSubmit: function (e) { return createUserFunc(e); } }, { children: [_jsx(Input, { label: t('users.table.headers.username'), type: "text", disabled: false, onChange: function (event) {
                        return setUsername(event.target.value);
                    }, fullWidth: true }), _jsx(LabeledMultiSelect, { values: userOwnerParties, options: adminOwnerParties, onChange: setUserOwnerParties, label: t('users.table.headers.ownerParties') }), _jsx(LabeledMultiSelect, { values: userAccessLevels, options: adminAccessLevels, onChange: setUserAccessLevels, label: t('users.table.headers.accessLevels') }), _jsx(FormActions, { submitText: t('general.save'), cancelLink: "/admin/useradmin" })] })) }));
};
export default CreateUser;
